<h1 mat-dialog-title dir="rtl">{{data.title}}</h1>
<div dir="rtl" mat-dialog-content >{{data.content}}</div>
<div dir="rtl" mat-dialog-actions>
  <button mat-stroked-button class="center" (click)="onNoClick()">בטל</button>
  <button mat-flat-button color="warn" class="center" (click)="onYesClick()">{{data.ok}}</button>
  
</div>